import { createElement } from "react";
import { Trans as I18nTrans, useTranslation } from "react-i18next";
import { i18n } from "./instance.js";
export function defineNamespace(name, en, loaders) {
    return {
        name,
        en,
        loaders,
        useT() {
            return useTranslation(name).t;
        },
        fixedT() {
            return i18n.getFixedT(null, name);
        },
        Trans({ k, values, components }) {
            return createElement(I18nTrans, { ns: name, i18nKey: k, values, components });
        },
    };
}
//# sourceMappingURL=namespace.js.map